import { inject, injectable } from "tsyringe";
import { RequestOptions } from "src/infra/http/types";
import type { Transaction } from "src/containers/crm/types";
import { HttpClient } from "src/infra/http/client";
import { autoBind } from "src/shared/decorators/autobind";
import { Environment } from "src/libs/environment";
import { Platform } from "src/libs/platform";
import { TransactionDto } from "src/containers/crm/dtos/transaction.dto";

@injectable()
export class CrmRepository {
    constructor(@inject("HttpClient") private http: HttpClient) { }

    static get userIdentity(): string {
        return window.userIdentity;
    }

    @autoBind
    saveTransaction(data: Transaction) {
        const isFlutter = Platform.isRunningOnFlutter();
        const endpoint = CrmRepository.getSaveTransactionUrl();
        const options: RequestOptions = {
            isPublicRequest: false,
            host: Environment.string("APIMGMT_URL"),
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(true), // true for isV2 of MS Base Headers
                ...this.http.httpUtils.getMsBaseHeaders(
                    CrmRepository.userIdentity,
                    "MEP"
                ),
                "x-device-type": isFlutter ? "APP" : "WEB",
            },
            data: TransactionDto.fromModel(data).asDtoObject(),
        };
        return this.http.post<void>(endpoint, options);
    }

    private static getSaveTransactionUrl() {
        return "miep/ux-gestion-tracking-clientes/v1/seguimiento-clientes";
    }
}
